module.exports = __webpack_public_path__ + "img/AHSPuzzleImage.ba275b6d.svg";